import { FC } from 'react';
import { HTHBuildingModalCheckbox } from './HTHBuildingModalCheckbox';
import { hthHelper } from 'src/services';
import { typeHTHBuilding, typeHTHHousehold } from '@monorepo/models';

type propsType = {
    currentBuilding: typeHTHBuilding;
    onClickHandler: (currentHousehold: typeHTHHousehold) => void;
};

export const HTHBuildingModalComplex: FC<propsType> = ({ currentBuilding, onClickHandler }) => {
    const state = hthHelper.GetComplexBuilding(currentBuilding);

    return (
        <div className={'d-flex justify-content-center mt-3'}>
            <div className={'d-flex'} style={{ maxWidth: '100%', overflowX: 'auto' }}>
                {state.map((el, column) =>
                    <div key={column} className={'justify-content-center'}>
                        {el.map((item, row) =>
                            <div key={`checkbox-${column}-${row}`}
                                style={{ display: 'flex', justifyContent: 'space-around' }}
                            >
                                {item.household ?
                                    <HTHBuildingModalCheckbox
                                        currentHousehold={item.household}
                                        isComplexBuilding={true}
                                        onClickHandler={onClickHandler}
                                    />
                                    :
                                    <div
                                        className={'my-2'}
                                        style={{
                                            borderRadius: '7px',
                                            marginInline: '10px',
                                            minHeight: '50px',
                                            paddingTop: '12px',
                                            width: '98px'
                                        }}
                                    >
                                    </div>
                                }
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
